export default [
  {
    title: "360° panorāma",
    key: "panorama",
    children: [
      {
        key: "panorama",
        title: "Visi objekti",
        img: [],
      },
    ],
  },
  {
    title: "Teritorijas",
    key: "services",
    children: [
      {
        key: "all-services",
        title: "Visi objekti",
        img: [],
      },
      {
        key: "k",
        title: "Kravām",
      },
      {
        key: "p",
        title: "Pasažieriem",
      },
      {
        key: "j",
        title: "Jahtām",
      },
      {
        key: "z",
        related: ["zalaszonas"],
        title: "Aizsargājamās teritorijas",
      },
      {
        key: "b",
        related: ["brivas"],
        title: "Brīvās teritorijas",
      },      
    ],
  },
  {
    title: "Kuģotājiem",
    key: "seafarers",
    children: [
      {
        key: "all-seafarers",
        title: "Visi objekti",
        img: [],
      },
      {
        key: "berths",
        related: ['berth_labels'],
        title: "Piestātnes",
        class: "blue",
        img: ["road.svg", "road-active.svg"],
      },
      // {
      //   key: "road",
      //   title: "Ostas ceļi",
      //   class: "blue",
      //   img: ["road.svg", "road-active.svg"],
      // },
      // {
      //   key: "depth",
      //   title: "Ceļu dziļumi",
      //   class: "blue",
      //   img: ["road.svg", "road-active.svg"],
      // },
    ],
  },

  {
    title: "Infrastruktūra",
    key: "infrastructure",
    children: [
      {
        key: "all-infrastructure",
        title: "Visi objekti",
        img: [],
      },
      {
        key: "port_railway",
        title: "Dzelzceļš ostā",
        class: "blue",
        img: ["road.svg", "road-active.svg"],
      },
    ]
  }

];
